import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, convertToDecimal, convertToSeparator, isNullOrEmpty } from '../../../../utils/util';
import { Table } from '../../../../components/UI/ComponentsUI';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';

const StatusDetail = (props) => {
    const { item } = props;

    const configItemColumns = () => [
        {
            field: 'partNumber',
            header: translate('container:fields:items:partNumber'),
            align: 'left',
            sortable: false
        },
        {
            field: 'totalQuantity',
            header: translate('container:fields:items:totalQuantity'),
            align: 'left',
            sortable: false
        },
        {
            field: 'boxQuantity',
            header: translate('container:fields:items:boxQuantity'),
            align: 'left',
            sortable: false
        },
        {
            field: 'mdr',
            header: translate('container:fields:items:mdr'),
            align: 'left',
            sortable: false
        },
        {
            field: 'baiCode',
            header: translate('container:fields:items:baiCode'),
            align: 'left',
            sortable: false
        },
        {
            field: 'lotNumber',
            header: translate('container:fields:items:lot'),
            align: 'left',
            sortable: false
        },
    ];

    return (
        <>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Status Container" }} />

            <div className="container-fluid" style={{ marginTop: 20 }} >
                <div className="container">
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <div className="input-field no-padding col s12">
                            <b className="field f-1r">{`${translate('container:fields:name')}`}</b>: {`${convertToSeparator(item.name) || ''}`}
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r"><b>{`${translate('container:fields:statusDescription')}`}</b>: {`${convertToDecimal(item.statusDescription) || ''}`}</span>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r"><b>{`${translate('container:fields:supplierName')}`}</b>: {`${convertToDecimal(item.supplierName) || ''}`}</span>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r"><b>{`${translate('container:fields:containerTypeName')}`}</b>: {`${convertToDecimal(item.containerTypeName) || ''}`}</span>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r"><b>{`${translate('container:fields:location')}`}</b>: {isNullOrEmpty(item.location) ? `${convertToDecimal(item.location) || ''}` : ''}</span>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r"><b>{`${translate('container:fields:freeTimeAvailable')}`}</b>: {`${convertToDecimal(item.freeTimeAvailable) || ''}`}</span>
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r"><b>Materiais</b>:</span>
                        </div>

                        <div className="input-field no-padding col s12 container-fluid">
                            <Table
                                col={configItemColumns()}
                                data={item.containerItem || []}
                                disablePaged
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        item: state.containerReducer.container
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StatusDetail));

